export default "__VITE_ASSET__CttR0UWJ__"